import React, { useState } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  Grid,
  Typography,
  Divider,
  DialogTitle,
} from "@material-ui/core";
import moment from "moment";

import Button from "../../components/Button";
import { Card, CardActions, CardContent } from "../../components/Card";
import { DateInput, TextInput } from "../../components/Form";
import PageItem from "../../components/PageItem";
import Table from "../../components/Table";

export default function WorkReportTable() {
  const datatest = [
    {
      number: "1",
      returnContent: "FB：0，電訪總通數：0，來電：0，面談：0，預約：0，電敗：0，拒絕：0，待追蹤：0 ",
      returnBusiness: "BO",
      returnDate: moment(new Date()).format("yyyy-MM-DD"),
      creatDate: moment(new Date()).subtract(7, "days").format("yyyy-MM-DD"),
    },
  ];
  const [newData, setNewData] = useState({
    open: false,
    state: "add",
    page: 1,
    pageMax: null,
    pageSize: 10,
    pageArray: [],
  });

  function changeDataListener(key, v) {}
  function changeData(key, v, rerender = false) {
    if (rerender) setNewData((prev) => ({ ...prev, [key]: v }));
    else setNewData((prev) => Object.assign(prev, { [key]: v }));
    if (typeof changeDataListener === "function") changeDataListener(key, v);
  }
  return (
    <Card>
      <CardContent>
        <Grid container spacing={1} justify="flex-end">
          <Button
            color="primary"
            variant="contained"
            onPress={() => {
              changeData("open", true);
              changeData("state", "add", true);
            }}
          >
            新增工作回報
          </Button>
          <WorkReportDialog
            open={newData.open}
            state={newData.state}
            onClose={() => changeData("open", false, true)}
          />
        </Grid>
        <Table
          data={datatest}
          tableWidth={2}
          header={["編號", "回報內容", "回報業務", "回報日期", "建立日期"]}
          columns={[
            "number",
            "returnContent",
            "returnBusiness",
            "returnDate",
            "creatDate",
          ]}
          onPress={() => {
            changeData("open", true);
            changeData("state", "check", true);
          }}
        />
      </CardContent>
      <CardActions>
        <PageItem
          data={newData.pageArray}
          page={newData.page}
          onChangePage={(e) => changeData("page", e, true)}
        />
      </CardActions>
    </Card>
  );
}

function WorkReportDialog({ open, state, onClose = () => {} }) {
  const [newData, setNewData] = useState({
    reportDate: new Date(),
    FBArticles: "",
    remarks: "",
  });

  function changeDataListener(key, v) {}
  function changeData(key, v, rerender = false) {
    if (rerender) setNewData((prev) => ({ ...prev, [key]: v }));
    else setNewData((prev) => Object.assign(prev, { [key]: v }));
    if (typeof changeDataListener === "function") changeDataListener(key, v);
  }

  return (
    <Dialog open={open} onClose={() => onClose()} fullWidth maxWidth={"sm"}>
      <Grid container spacing={1} justify="center">
        <DialogTitle>
          {state === "add"
            ? "新增工作回報"
            : moment(new Date()).format("yyyy-MM-DD") + "今日工作回報"}
        </DialogTitle>
      </Grid>
      <DialogContent dividers>
        <Grid container spacing={1}>
          {state === "add" && (
            <Grid item sm={6}>
              <Typography color="primary">回報日期</Typography>
              <DateInput
                value={newData.reportDate}
                format="yyyy年MM月dd日"
                onChange={(v) => {
                  changeData("reportDate", v, true);
                }}
                fullWidth
              />
            </Grid>
          )}

          <Grid item sm={6}>
            <Typography color="primary">FB PO文</Typography>
            {state === "add" ? (
              <TextInput
                placeholder="幾則法拍屋"
                value={newData.FBArticles}
                onChange={(v) => {
                  changeData("FBArticles", v, true);
                }}
                fullWidth
              />
            ) : (
              <Typography>0 則法拍屋</Typography>
            )}
          </Grid>
        </Grid>
      </DialogContent>
      <DialogContent dividers>
        <Grid container spacing={2}>
          <Grid item sm={3}>
            <Typography color="primary">電訪總通數</Typography>
            <Typography>0通</Typography>
          </Grid>
          <Grid item sm={2}>
            <Typography color="primary">來電</Typography>
            <Typography>0通</Typography>
          </Grid>
          <Grid item sm={2}>
            <Typography color="primary">面談</Typography>
            <Typography>0通</Typography>
          </Grid>
          <Grid item sm={2}>
            <Typography color="primary">預約</Typography>
            <Typography>0通</Typography>
          </Grid>
          <Grid item sm={2}>
            <Typography color="primary">電敗</Typography>
            <Typography>0通</Typography>
          </Grid>
          <Grid item sm={2}>
            <Typography color="primary">拒絕</Typography>
            <Typography>0通</Typography>
          </Grid>
          <Grid item sm={2}>
            <Typography color="primary">待追蹤</Typography>
            <Typography>0通</Typography>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogContent dividers>
        <Grid item>
          <Typography color="primary">備註說明</Typography>
          {state === "add" ? (
            <TextInput
              multiline
              rows={5}
              value={newData.remarks}
              onChange={(v) => {
                changeData("remarks", v, true);
              }}
              fullWidth
            />
          ) : (
            <Typography>test</Typography>
          )}
        </Grid>
      </DialogContent>
      <DialogContent dividers>
        <Grid item>
          <Typography color="primary">追蹤業務</Typography>
          <Typography>test</Typography>
        </Grid>
      </DialogContent>
      {state === "check" ? (
        <>
          <Grid container spacing={1} justify="center">
            <DialogTitle>
              {moment(new Date()).format("yyyy-MM-DD") + "聯絡客戶名單"}
            </DialogTitle>
          </Grid>
          <DialogContent dividers>
            <Grid item>
              <Typography color="primary">test來電</Typography>
              <Typography>test</Typography>
            </Grid>
          </DialogContent>
        </>
      ) : null}
      <DialogActions>
        <Grid container spacing={1} justify="center">
          <Grid item>
            <Button
              color="primary"
              variant="contained"
              onPress={() => {
                onClose();
              }}
            >
              送出
            </Button>
          </Grid>
          <Grid item>
            <Button
              color="primary"
              variant="outlined"
              onPress={() => {
                onClose();
              }}
            >
              返回
            </Button>
          </Grid>
        </Grid>
      </DialogActions>
    </Dialog>
  );
}
